import { ComponentReferencesV2 } from "./component-references-v2";

export class OrderLineStateV2 {

	public Id: number;
	public Uuid: string;

	public ComponentVariantBypass: boolean;
	public ComponentSizeBypass: boolean;
	public SplittingData: boolean;
	public Optional: boolean;
	public IsDiscontinued: boolean;
	public IsNew: boolean;
	public EngravingPossible: number;

	public ComponentVariantCode: string;
	public ComponentSizeCode: string;
	public ColorCode: string;
	public ColorGroupCode: string;
	public ColorLineCode: string;
	public ComponentCode: string;

	public ComponentVariantUuid: string;
	public ComponentSizeUuid: string;
	public ComponentColorUuid: string;
	public ComponentUuid: string;

	// Add missing numeric ID properties needed for Original* object mapping
	public ComponentVariantId: number;
	public ComponentSizeId: number;
	public ComponentColorId: number;
	public ComponentId: number;
	public ColorId: number;

	public get isDiscontinued(): boolean {
		return this.IsDiscontinued;
	}

	public get isNew(): boolean {
		return this.IsNew;
	}

	public getVariantDescription(componentReferences?: ComponentReferencesV2): string {
		if (componentReferences?.Variants && this.ComponentVariantUuid) {
			const ref = componentReferences.Variants[this.ComponentVariantUuid];
			if (ref?.Description) {
				return ref.Description;
			}
		}

		return this.ComponentVariantCode;
	}

	public getSizeDescription(componentReferences?: ComponentReferencesV2): string {
		if (componentReferences?.Sizes && this.ComponentSizeUuid) {
			const ref = componentReferences.Sizes[this.ComponentSizeUuid];
			if (ref?.Description) {
				return ref.Description;
			}
		}

		return this.ComponentSizeCode;
	}

	public getColorDescription(componentReferences?: ComponentReferencesV2): string {
		if (componentReferences?.Colors && this.ComponentColorUuid) {
			const ref = componentReferences.Colors[this.ComponentColorUuid];
			if (ref?.Description) {
				return ref.Description;
			}
		}

		return this.ColorCode;
	}

	public getColorGroupDescription(componentReferences?: ComponentReferencesV2): string {
		if (componentReferences?.Colors && this.ComponentColorUuid) {
			const ref = componentReferences.Colors[this.ComponentColorUuid];
			if (ref?.GroupDescription) {
				return ref.GroupDescription;
			}
		}

		return this.ColorGroupCode;
	}

	public getComponentDescription(componentReferences?: ComponentReferencesV2): string {
		if (componentReferences?.Components && this.ComponentUuid) {
			const ref = componentReferences.Components[this.ComponentUuid];
			if (ref?.Description) {
				return ref.Description;
			}
		}

		return this.ComponentCode;
	}

} 